import { RouterModule, Routes } from '@angular/router';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { VmeCommonModule } from '../../../vme-common.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { EmergencyContactComponent } from './emergency-contact.component';

const routes: Routes = [{ path: '', component: EmergencyContactComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmergencyContactRoutingModule {}

@NgModule({
  imports: [
    EmergencyContactRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [EmergencyContactComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmergencyContactModule {}
